import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedTextProps {
  text: string;
  className?: string;
  delay?: number;
  type?: 'fade' | 'slide' | 'scale' | 'typewriter';
}

const AnimatedText: React.FC<AnimatedTextProps> = ({ 
  text, 
  className = '', 
  delay = 0, 
  type = 'fade' 
}) => {
  const animations = {
    fade: {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.6, delay }
    },
    slide: {
      initial: { opacity: 0, x: -50 },
      animate: { opacity: 1, x: 0 },
      transition: { duration: 0.8, delay }
    },
    scale: {
      initial: { opacity: 0, scale: 0.8 },
      animate: { opacity: 1, scale: 1 },
      transition: { duration: 0.6, delay }
    },
    typewriter: {
      initial: { width: 0 },
      animate: { width: 'auto' },
      transition: { duration: 2, delay }
    }
  };

  const selectedAnimation = animations[type];

  if (type === 'typewriter') {
    return (
      <motion.div
        className={`overflow-hidden whitespace-nowrap ${className}`}
        {...selectedAnimation}
      >
        {text}
      </motion.div>
    );
  }

  return (
    <motion.div
      className={className}
      {...selectedAnimation}
    >
      {text}
    </motion.div>
  );
};

export default AnimatedText;